export const SUPPORTED_USER_ROLES = ['CHAIRMAN', 'ABONENT', 'OPERATOR', 'NOTARIUS'];
export const ADMIN_ROLE = 'ADMIN';

// OSI-808 п.7: роли, которым остаётся ВИДНА кнопка «Прикрепить» (импорт Excel).
// Места применения — два:
//   1) раздел «Помещения / Квартиры» (/osi/abonents) — widgets/osi/abonents/ui/ImportAbonentsButton.tsx;
//   2) вкладка «Начальное сальдо» раздела «Начисление платежей» (/osi/accruals)
//      — widgets/osi/osiServiceSaldo/ui/AttachSaldoButton.tsx.
// Всем прочим ролям (CHAIRMAN, CHAIRMAN_TRUSTED, CHAIRMAN_TRUSTED_READONLY, ABONENT, NOTARIUS)
// кнопка НЕ рендерится вовсе (не disabled). Гейт чисто UI-шный: эндпоинты импорта заказчиком
// в рамках п.7 намеренно не закрывались.
// Тип — string, а не keyof typeof UserRoles: MAIN_OPERATOR есть в OSI.Core/Auth/Roles.cs,
// но во фронтовом enum UserRoles (app/stores/mobx/interfaces/index.ts) его нет,
// при этом роль реально приезжает с бэка строкой.
export const ATTACH_BUTTON_ALLOWED_ROLES = new Set<string>(['OPERATOR', 'ADMIN', 'MAIN_OPERATOR']);
